const fadein = () => {
  const fadeElement = document.querySelector('.fade-in');
  if (fadeElement) {
    fadeElement.classList.remove('fade-in-active');
    setTimeout(() => {
      fadeElement.classList.add('fade-in-active');
    }, 10);
  }
}

export default fadein;